/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_CustomerService_Dtos_Dashboard_AdminDashboardResponseDto } from '../models/Wealthlane_CustomerService_Dtos_Dashboard_AdminDashboardResponseDto';
import type { Wealthlane_CustomerService_Dtos_Dashboard_AuditTrailsSummaryResponseDto } from '../models/Wealthlane_CustomerService_Dtos_Dashboard_AuditTrailsSummaryResponseDto';
import type { Wealthlane_CustomerService_Dtos_Dashboard_CustomerParticipantDashboardResponseDto } from '../models/Wealthlane_CustomerService_Dtos_Dashboard_CustomerParticipantDashboardResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DashboardService {

    /**
     * @returns Wealthlane_CustomerService_Dtos_Dashboard_CustomerParticipantDashboardResponseDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppDashboardParticipantDashboard(): CancelablePromise<Wealthlane_CustomerService_Dtos_Dashboard_CustomerParticipantDashboardResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/dashboard/participant-dashboard',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_CustomerService_Dtos_Dashboard_AuditTrailsSummaryResponseDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppDashboardParticipantPastActivitiesSummary(): CancelablePromise<Wealthlane_CustomerService_Dtos_Dashboard_AuditTrailsSummaryResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/dashboard/participant-past-activities-summary',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_CustomerService_Dtos_Dashboard_AdminDashboardResponseDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppDashboardAdminDashboard(): CancelablePromise<Wealthlane_CustomerService_Dtos_Dashboard_AdminDashboardResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/dashboard/admin-dashboard',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
